import EDocumentImportWizard from "@components/content/EDocumentImportWizard";
import invoiceImportDefinition from "@utils/edocumentImport/definitions/invoiceImport";

/**
 * Carga masiva de facturas y tiquetes electronicos ya emitidos.
 *
 * Toda la logica vive en el asistente agnostico y en la definicion del documento: esta pagina
 * solo elige cual. Las notas de credito y debito seran otra pagina igual de corta.
 */
const InvoiceImport = () => <EDocumentImportWizard definition={invoiceImportDefinition} />;

export default InvoiceImport;
